import { Button, Dialog, type DialogRef } from '@myosh/odin-components';
import type { Ref, RefObject } from 'react';

interface AddItemDialogProps {
  onSubmit: () => void;
  errorTextRef: RefObject<HTMLParagraphElement | null>;
  inputRef: RefObject<HTMLInputElement | null>;
  disabled?: boolean;
  ref?: Ref<DialogRef>;
}

const AddItemDialog = ({ onSubmit, errorTextRef, inputRef, disabled, ref }: AddItemDialogProps) => (
  <Dialog ref={ref} data-cy="add-item-dialog" header="Add new item" size="sm" showCloseButton={false}>
    <div className="flex flex-col gap-4">
      <div className="w-full">
        <label htmlFor="add-new-item-input" className="flex self-start font-medium text-sm">
          New item
        </label>
        <input
          data-cy="add-item-dialog-input"
          disabled={disabled}
          placeholder="Enter new item"
          ref={inputRef}
          id="add-new-item-input"
          name="add-new-item-input"
          className="flex w-full flex-1 appearance-none rounded-sm border border-border px-2 py-1 text-sm focus:outline-hidden"
        />
        <p data-cy="add-item-dialog-error" className="hidden text-error text-xs" ref={errorTextRef} />
      </div>
      <Button className="w-full" data-cy="add-item-dialog-submit" disabled={disabled} onClick={onSubmit}>
        Submit
      </Button>
    </div>
  </Dialog>
);

export default AddItemDialog;
